import React from 'react'
import js from "../Image/js.png";
import npm from "../Image/npm.png";
import tailwind from "../Image/tailwind.jpeg";
import express from "../Image/expressjs_logo.png";
import postman from "../Image/postman.png";
import vercel from "../Image/vercel.png";
import firebase from "../Image/firebase.png"
import html from "../Image/html.png"
import css from "../Image/css.png"
import react from "../Image/reactl.png"
import redux from "../Image/redux.png"
import mongo from "../Image/mongo.png"
import node from "../Image/node.png"
import chakraui from "../Image/chakra-ui.png"


export const Skill = () => {
    return (
        <section id="skills" className="skillCOnt">
            <div className="heading">
                <h2>My Skills</h2>
                <span>Tech Stack & Tools</span>
            </div>
            <div className="skills-content">

                <div className="skills-card">
                    <img className="skills-card-img" src={html} alt="html" />
                    <h4 className="skills-card-name">HTML</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src={css} alt="css" />
                    <h4 className="skills-card-name">CSS</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={js} alt="js" />
                    <h4 className="skills-card-name">JavaScript</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src={react} alt="react" />
                    <h4 className="skills-card-name">React</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={redux} alt="redux" />
                    <h4 className="skills-card-name">Redux</h4>
                </div>


                <div className="skills-card">
                    <img className="skills-card-img" src={tailwind} alt="Tailwind" />
                    <h4 className="skills-card-name">Tailwind</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src={mongo} alt="mongo" />
                    <h4 className="skills-card-name">Mongo Db</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src={express} alt="redux" />
                    <h4 className="skills-card-name">Express JS</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={node} alt="node" />
                    <h4 className="skills-card-name">Node JS</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src="https://i.ibb.co/fFB8RbJ/netlify-logo-png-transparent.png" alt="netlify" />
                    <h4 className="skills-card-name">Netlify</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={vercel} alt="redux" />
                    <h4 className="skills-card-name">Vercel</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={firebase} alt="redux" />
                    <h4 className="skills-card-name">Firebase</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src={chakraui} alt="chakra" />
                    <h4 className="skills-card-name">Chakra-ui</h4>
                </div>
                <div className="skills-card">
                    <img className="skills-card-img" src="https://i.ibb.co/wzFbW7R/25231.png" alt="github" />
                    <h4 className="skills-card-name">GitHub</h4>
                </div>

                <div className="skills-card">
                    <img className="skills-card-img" src={postman} alt="vscode" />
                    <h4 className="skills-card-name">Postman</h4>
                </div>
            </div>
        </section>
    )
}
